import { useState } from "react";
import { setFlashMessage, userIsLogged, userRedirectLogin } from "../../helpers"
import { API_ROUTES } from "../../constants/apiRoutes"
import apiClient from "../../services/api/apiClient"
import House from "./House"
import loaderGif from '../../resources/img/loader3.gif'
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);


class HouseElecManager {

    loadConsoIntoTemplate() {
        return new Promise((resolve, reject) => {
            this._setIsLoading(true)
            if (!this.canvasCharts) {
                this.canvasCharts = []
            }
            // Clean canvas charts
            ['elecConsoDailyCanvas', 'elecConsoMonthlyCanvas', 'elecConsoHourlyCanvas'].forEach((element) => {
                this.canvasCharts[element] ? this.canvasCharts[element].destroy() && delete this.canvasCharts[element] : null
            })
            let pdl = this._contratElecPDL
            let url = API_ROUTES.ELEC_GET_CONSO + '?pdl=' + pdl
            apiClient.get(url).then((data) => {
                const consoDaily = data.daily
                const consoHourly = data.hourly
                const consoMonthly = data.monthly
                const consoDailyCe = data.dailyCe
                const consoMonthlyCe = data.monthlyCe
                const consoDailyShogun = data.dailyShogun
                const consoMonthlyShogun = data.monthlyShogun
                let chartDailyDataLabels = [], chartDailyDataPoints = [], chartDailyCeDataPoints = [], chartDailyShogunDataPoints = []
                let chartHourlyDataLabels = [], chartHourlyDataPoints = []
                let chartMonhtlyDataLabels = [], chartMonthlyDataPoints = [], chartMonthlyCeDataPoints = [], chartMonthlySHogunDataPoints = []
                const kwhPrice = data.kwhPrice
                if (!consoDaily && !consoMonthly && !consoHourly) {
                    setFlashMessage('error', 'Erreur lors de la récupération des données de consommation électrique : pas de données disponibles')
                    return
                }
                if (consoDaily) {
                    const dailyWrapper = document.getElementById('elecConsoDailyCanvasWrapper')
                    const monthlyWrapper = document.getElementById('elecConsoMonthlyCanvasWrapper')
                    const hourlyWrapper = document.getElementById('elecConsoHourlyCanvasWrapper')
                    if (dailyWrapper) {
                        dailyWrapper.innerHTML = '<canvas id="elecConsoDailyCanvas" style="height:45vw; max-height:300px"></canvas>'
                    }
                    if (monthlyWrapper) {
                        monthlyWrapper.innerHTML = '<canvas id="elecConsoMonthlyCanvas" style="height:55vw; max-height:350px"></canvas>'
                    }
                    if (hourlyWrapper) {
                        hourlyWrapper.innerHTML = '<canvas id="elecConsoHourlyCanvas" style="height:45vw; max-height:300px"></canvas>'
                    }
                    Object.keys(consoDaily).forEach((date) => {
                        const dt = date.split('-')
                        const dateReworked = dt[2] + ' / ' + dt[1]
                        const consoDay = (consoDaily[date] / 1000).toFixed(1)
                        chartDailyDataLabels.push(dateReworked)
                        if (this._consoElecUnitEuro === true) {
                            chartDailyDataPoints.push((consoDay * kwhPrice).toFixed(2))
                        } else {
                            chartDailyDataPoints.push(consoDay)
                        }
                    })
                    if (consoMonthly) {
                        Object.keys(consoMonthly).forEach((monthYear) => {
                            const dt = monthYear.split('-')
                            const dateReworked = dt[1] + ' / ' + dt[0]
                            const consoMonth = (consoMonthly[monthYear] / 1000).toFixed(0)
                            if (consoMonth > 0) {
                                chartMonhtlyDataLabels.push(dateReworked)
                                if (this._consoElecUnitEuro === true) {
                                    chartMonthlyDataPoints.push((consoMonth * kwhPrice).toFixed(2))
                                } else {
                                    chartMonthlyDataPoints.push(consoMonth)
                                }
                            }
                        })
                    }
                    if (consoDailyCe) {
                        Object.keys(consoDailyCe).forEach((date) => {
                            const consoDay = (consoDailyCe[date] / 1000).toFixed(1)
                            if (this._consoElecUnitEuro === true) {
                                chartDailyCeDataPoints.push((consoDay * kwhPrice).toFixed(2))
                            } else {
                                chartDailyCeDataPoints.push(consoDay)
                            }
                        })
                    }
                    if (consoDailyShogun) {
                        Object.keys(consoDailyShogun).forEach((date) => {
                            const consoDay = (consoDailyShogun[date] / 1000).toFixed(1)
                            if (this._consoElecUnitEuro === true) {
                                chartDailyShogunDataPoints.push((consoDay * kwhPrice).toFixed(2))
                            } else {
                                chartDailyShogunDataPoints.push(consoDay)
                            }
                        })
                    }
                    if (consoMonthly && consoMonthlyCe) {
                        Object.keys(consoMonthlyCe).forEach((date) => {
                            if (consoMonthly[date] > 0) {
                                const consoMonth = (consoMonthlyCe[date] / 1000).toFixed(0)
                                if (this._consoElecUnitEuro === true) {
                                    chartMonthlyCeDataPoints.push((consoMonth * kwhPrice).toFixed(2))
                                } else {
                                    chartMonthlyCeDataPoints.push(consoMonth)
                                }
                            }
                        })
                    }
                    if (consoMonthly && consoMonthlyShogun) {
                        Object.keys(consoMonthlyShogun).forEach((date) => {
                            if (consoMonthly[date] > 0) {
                                const consoMonth = (consoMonthlyShogun[date] / 1000).toFixed(0)
                                if (this._consoElecUnitEuro === true) {
                                    chartMonthlySHogunDataPoints.push((consoMonth * kwhPrice).toFixed(2))
                                } else {
                                    chartMonthlySHogunDataPoints.push(consoMonth)
                                }
                            }
                        })
                    }
                    // Clean canvas charts
                    ['elecConsoDailyCanvas', 'elecConsoMonthlyCanvas', 'elecConsoHourlyCanvas'].forEach((element) => {
                        this.canvasCharts[element] ? this.canvasCharts[element].destroy() && delete this.canvasCharts[element] : null
                    })

                    this._buildChart('bar', document.getElementById('elecConsoDailyCanvas'), chartDailyDataLabels, [chartDailyDataPoints, chartDailyShogunDataPoints, chartDailyCeDataPoints], true, ["Conso TOT", "Conso Shogun", "Conso CE"])
                    this._buildChart('bar', document.getElementById('elecConsoMonthlyCanvas'), chartMonhtlyDataLabels, [chartMonthlyDataPoints, chartMonthlySHogunDataPoints, chartMonthlyCeDataPoints], true, ["Conso TOT", "Conso Shogun", "Conso CE"])
                    const consoPart = document.getElementById('elecConsoPart')
                    if (consoPart) {
                        consoPart.classList.remove('d-none')
                    }
                }
                if (consoHourly) {
                    Object.keys(consoHourly).forEach((hour) => {
                        const hours = hour.split(':')
                        const hourReworked = hours[0] + 'h' + hours[1]
                        const consoHour = (consoHourly[hour] / 1000).toFixed(1)
                        chartHourlyDataLabels.push(hourReworked)
                        if (this._consoElecUnitEuro === true) {
                            chartHourlyDataPoints.push((consoHour * kwhPrice).toFixed(2))
                        } else {
                            chartHourlyDataPoints.push(consoHour)
                        }
                    })
                    this._buildChart('bar', document.getElementById('elecConsoHourlyCanvas'), chartHourlyDataLabels, [chartHourlyDataPoints], true, ["Conso / 24H"])
                }
            }).catch((error) => {
                setFlashMessage('error', 'Erreur lors de la récupération des données de consommation électrique')
            }).finally(() => {
                this._setIsLoading(false)
                resolve()
            })
        })
    }

    _buildChart(chartType, canvasElement, dataLabels, dataPoints, useDataLabels = true, labels = null) {
        if (!canvasElement) {
            return
        }

        const options = { backgroundColor: '#2865a7' }
        let plugins = []
        if (useDataLabels === true) {
            options.plugins = {
                datalabels: {
                    color: 'black',
                    align: 'end',
                    anchor: 'end',
                    font: { weight: 'bold' },
                }
            }
            plugins = [ChartDataLabels]
        }
        options.pointBorderWidth = 6
        options.pointHoverBorderWidth = 12

        const backgroundColors = ['#2865a7', '#9d711d', '#9b9338']
        let dataSets = []

        dataPoints.forEach((item, index) => {
            let dataLabelsCurrentData = {
                align: 'end',
                anchor: 'end',
                color: backgroundColors[index],
                offset: 5
            }
            dataSets.push({
                backgroundColor: backgroundColors[index],
                label: labels[index],
                data: dataPoints[index],
                borderColor: backgroundColors[index],
                fill: false,
                datalabels: dataLabelsCurrentData
            })
        })

        let barChart = new Chart(canvasElement, {
            type: chartType,
            plugins: plugins,
            data: {
                labels: dataLabels,
                datasets: dataSets,
            },
            options: options
        })
        this.canvasCharts[canvasElement.id] = barChart
    }


    searchAdr() {
        let adrSearch = this._contratElecAdr
        let adrSearchName = this._contratElecName

        if (!adrSearch || !adrSearchName || adrSearch.length < 10 || adrSearchName.length < 3) {
            return
        }

        const postData = {
            adr: adrSearch,
            name: adrSearchName
        }
        let url = API_ROUTES.ELEC_SEARCH_ADR
        apiClient.post(url, postData).then((data) => {
            if (data.isSuccess !== true) {
                setFlashMessage('warning', 'Impossible de trouver un PDL valide à partir de l\'adresse et du nom fourni')
            } else {
                const adrResult = data.pdl + ' | ' + data.contractStatus
                this._setContratElecAdrResult(adrResult)
                if (data.pdl) {
                    this._setContratElecPDL(data.pdl)
                }
            }
        }).catch((error) => {
            setFlashMessage('error', 'Erreur lors de la recherche de l\'adresse : ' + error.message)
        })
    }







}
export default function HouseElec() {



    const [isLogged, setIsLogged] = useState(false)
    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                userRedirectLogin()
            }
            setIsLogged(isLogged)
        })
    }

    const manager = new HouseElecManager()
    const [consoElecUnitEuro, setSonsoElecUnitEuro] = useState(false)
    const [isLoading, setIsLoading] = useState(null)
    const [contratElecAdr, setContratElecAdr] = useState(null)
    const [contratElecName, setContratElecName] = useState(null)
    const [contratElecPDL, setContratElecPDL] = useState(null)
    const [contratElecAdrResult, setContratElecAdrResult] = useState(null)

    manager._consoElecUnitEuro = consoElecUnitEuro
    manager._setIsLoading = setIsLoading
    manager._contratElecAdr = contratElecAdr
    manager._contratElecName = contratElecName
    manager._contratElecPDL = contratElecPDL
    manager._setContratElecPDL = setContratElecPDL
    manager._setContratElecAdrResult = setContratElecAdrResult

    if (isLoading === null && isLogged === true) {
        manager.loadConsoIntoTemplate()
    }

    function clearSearchAdr() {
        setContratElecAdr(null)
        setContratElecName(null)
        setContratElecPDL(null)
        manager.loadConsoIntoTemplate()
    }

    if (isLogged) {
        return (
            <>
                <House activeTab="elec" />
                <div className="conteneur">
                    <div id="flashMessages"></div>
                    <div id="elecConsoPart">
                        <div className="text-center">
                            <h4><i className="fa fa-bolt small"></i> Conso électrique</h4>
                            <div className="text-center">
                                <strong>Kw/H</strong>
                                <button className={"btn btn-toggle " + (consoElecUnitEuro ? 'enabled' : '')} onClick={() => { setIsLoading(null); setSonsoElecUnitEuro(!consoElecUnitEuro) }}>
                                    <span className="btn-toggle-content"></span>
                                </button>
                                <strong>&nbsp;€</strong>
                                <br /><br />
                                <img src={loaderGif} className={isLoading !== true ? "d-none" : ''} style={{ width: "25%", maxWidth: '150px' }} id="loaderElec" />
                            </div>
                            <br />

                            <div style={{ width: '100%', overflowX: "auto", overflowY: "hidden", direction: 'rtl' }}>
                                <div style={{ width: "700px", height: "300px", maxWidth: '2000px', direction: 'ltr' }}>
                                    <div id="elecConsoDailyCanvasWrapper" className={isLoading === true ? "d-none" : ''}></div>
                                </div>
                            </div>
                            <div style={{ width: '100%', overflowX: "auto", overflowY: "hidden", direction: 'rtl' }}>
                                <div style={{ width: "1200px", height: "350px", direction: 'ltr' }}>
                                    <div id="elecConsoMonthlyCanvasWrapper" className={isLoading === true ? "d-none" : ''}></div>
                                </div>
                            </div>
                            <div className="mb-5" style={{ width: '100%', overflowX: "auto", overflowY: "hidden", direction: 'rtl' }}>
                                <div style={{ width: "2000px", height: "300px", direction: 'ltr' }}>
                                    <div id="elecConsoHourlyCanvasWrapper" className={isLoading === true ? "d-none" : ''}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>)
    }
}
